import { Div, DivProps, Image, ImageProps, P } from '@kizi/core-components';
import React from 'react';

export interface AvatarMobileProps extends DivProps {
  imageProps?: ImageProps;
  name: string;
  role: string;
  url: string;
}

export const AvatarMobile: React.FC<AvatarMobileProps> = React.forwardRef<
  HTMLDivElement,
  AvatarMobileProps
>(({ imageProps, name, role, url, ...divProps }, ref) => {
  return (
    <Div
      alignItems="center"
      display={['flex', 'flex', 'none', 'none']}
      flexDirection="row"
      ref={ref}
      variant="avatar"
      css={{
        gap: '8px',
      }}
      {...divProps}
    >
      <Image alt="" src={url} {...imageProps} />
      <Div
        alignItems="center"
        display={['flex']}
        flexDirection="column"
        justifyContent="center"
      >
        <P
          textAlign="center"
          variant="headlineImportant"
          css={{
            fontSize: 12,
          }}
        >
          {name}
        </P>
        <P
          variant="footnoteRegular"
          css={{
            fontSize: 12,
            mt: '0px !important',
          }}
        >
          {role}
        </P>
      </Div>
    </Div>
  );
});
